import {appName} from "../config";
import {getFormValues} from "redux-form";
import results from "../mocks/results";
import trackEvent from "../services/track-event";

/**
 * Constants
 * */
export const moduleName = `results`;
const prefix = `${appName}/${moduleName}`;

export const GET_RESULTS = `${prefix}/GET_RESULTS`;
export const RESET_RESULTS = `${prefix}/RESET_RESULTS`;

/**
 * Reducer
 * */

export default function reducer(state = null, action) {
  const {type, payload} = action;

  switch (type) {
    case GET_RESULTS:
      return payload.result;

    case RESET_RESULTS:
      return null;

    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const stateSelector = (state) => state[moduleName];
export const haveResultsSelector = (state) => !!state[moduleName];

/**
 * Action Creators
 * */

export const getResults = () => (dispatch, getState) => {
  const {gender, age, whom, hobby} = getFormValues(`quiz`)(getState());
  let result;
  if (gender === `male` && age >= 18) {
    result = results[`man`];
  } else if (gender === `female` && age >= 18) {
    result = results[`woman`];
  } else {
    result = results[`child`];
  }
  trackEvent({
    category: `quiz button`,
    action: `quiz button click`,
    label: `${gender}-${whom}-${age}-${hobby}`
  });
  dispatch({
    type: GET_RESULTS,
    payload: {
      result
    }
  });
};

export const resetResults = {
  type: RESET_RESULTS
};
